import React from 'react';
import { ComingSoonPage } from './pages';

const App: React.FC = () => {
	return <ComingSoonPage />;
};

export default App;
